import { createReducer, on } from '@ngrx/store';
import { AvailableLookupOsUpdateApiActions } from './available-lookup-os-update.actions';
import { adapter, initialState } from './available-lookup-os-update.state';

export const AvailableLookupOsUpdateFeatureKey = 'availableLookupOsUpdate';

export const AvailableLookupOsUpdateReducer = createReducer(
  initialState,
  on(AvailableLookupOsUpdateApiActions.availableLookupOSUpdatesLoaded, (state, { availableLookupOsUpdates }) =>
    adapter.upsertMany(availableLookupOsUpdates, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAvailableLookupOsUpdateIds = selectIds;

export const selectAvailableLookupOsUpdateEntities = selectEntities;

export const selectAvailableLookupOsUpdate = selectAll;
